
import api from "../../../../../api/api"


const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/ledger-entry?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getByLedgerId = (ledgerId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/ledger-entry/"+ledgerId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getBalanceByLedgerId = (ledgerId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/ledger-entry/balance/"+ledgerId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const ledgerEntryServices = {
    getList,
    getByLedgerId,
    getBalanceByLedgerId,
}
export default ledgerEntryServices;